module.exports = __webpack_public_path__ + "img/back.f4912094.svg";